import { CmsObjectWithDefault } from '@components/Cms/types';

export type SocialLoginButtonsViewCmsKey =
    | 'googleButton'
    | 'facebookButton'
    | 'appleButton'
    | 'weChatButton'
    | 'signInWithApple'
    | 'kakaoButton'
    | 'lineButton'
    | 'whatsappButton';

export const SocialLoginButtonsViewCmsWithDefault: CmsObjectWithDefault<SocialLoginButtonsViewCmsKey> = {
    googleButton: {
        cmsId: 114866,
        defaultTranslation: 'Google',
    },
    facebookButton: {
        cmsId: 109025,
        defaultTranslation: 'Facebook',
    },
    appleButton: {
        cmsId: 109026,
        defaultTranslation: 'Apple',
    },
    weChatButton: {
        cmsId: 109058,
        defaultTranslation: 'WeChat',
    },
    signInWithApple: {
        cmsId: 225092,
        defaultTranslation: 'Sign in with Apple',
    },
    kakaoButton: {
        cmsId: 332659,
        defaultTranslation: 'Kakao',
    },
    lineButton: {
        cmsId: 349748,
        defaultTranslation: 'Line',
    },
    whatsappButton: {
        cmsId: 362427,
        defaultTranslation: 'WhatsApp',
    },
};
